module.exports = __webpack_public_path__ + "img/mobilepartyterminal2.59353bfc.png";